module.exports = __webpack_public_path__ + "img/7.c3d7d9c9.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1386,"height":806,"variants":[{"file":"img/7-480w.4b713fde6ced.webp","width":480},{"file":"img/7-960w.814488b42339.webp","width":960},{"file":"img/7-1386w.2d9d73efbad0.webp","width":1386}]};
}